/** Tab keys inside the participants widget. */
export enum CardParticipantsTabKeyEnum {
  MEMBERS = 'MEMBERS',
  FILES = 'FILES',
  HISTORY = 'HISTORY',
}
